import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { CreatePlayload, DecodeToken } from "../../lib/token";
import { ablyClient } from "../../lib/socket";
import axi from "../../lib/axios";
import { signupSuccess } from "./signup";
import { addBonusModal, completedModals } from "./gift";
import { registerAndSaveFcmToken } from "../../lib/fcm";
const channel = ablyClient.channels.get("general-chat");
const GEtUserData = (payload) => {
  const getToken = DecodeToken(payload);
  const user = DecodeToken(getToken?.token);
  return user;
};

const initialState = {
  isAuthenticated: !!GEtUserData(localStorage.getItem("logged")) || false,
  user: GEtUserData(localStorage.getItem("logged")) || null,
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    requestStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    loginSuccess: (state, action) => {
      state.isAuthenticated = true;
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.loading = false;
      state.error = null;
    },
    requestFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.isAuthenticated = false;
      state.user = null;
      state.token = null;
      localStorage.removeItem("logged");
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      state.token = null;
      localStorage.removeItem("logged");
      localStorage.removeItem("fcmToken");
      // channel.presence.unsubscribe();
      if (channel?.state === "joined") {
        channel.presence.leave();
      }
    },
  },
});

// Export actions and reducer
export const { requestStart, loginSuccess, requestFailure, logout } =
  authSlice.actions;
export default authSlice.reducer;

// Login action
export const Signin = (data, navigate) => async (dispatch) => {
  try {
    dispatch(requestStart());

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/public/login`,
      data
    );
    if (response?.status === 200) {
      const { user, token, verifyToken } = response.data;

      if (!user.verified) {
        localStorage.setItem("acs", verifyToken);
        dispatch(signupSuccess(verifyToken));
        toast.info("Please verify your account first");
        navigate("/signup");
      } else if (token) {
        await channel.presence.enter(user);
        dispatch(loginSuccess({ user, token }));

        const Token = CreatePlayload(CreatePlayload(user));
        localStorage.setItem("logged", Token?.token);
        //Checking if the gift modal is not previously opened
        if (!completedModals.find((item) => item === "deposit")) {
          dispatch(addBonusModal("deposit"));
        }

        // Save FCM token so admin can push notifications
        registerAndSaveFcmToken(user?.email);

        navigate("/dashboard");
        toast.success("You are successfully logged in.");
      } else {
        throw new Error("No token received");
      }
    }
  } catch (err) {
    toast.error(
      err?.response?.data?.message || err?.response?.message || "Login failed!"
    );
    dispatch(
      requestFailure(err?.response?.data?.message || "Something went wrong!")
    );
  }
};

export const LOGOUTAtive = (navigate) => async (dispatch) => {
  try {
    const data = {
      b1: 64,
      b2: 64,
    };

    const response = await axi.post(`/private/log`, data);
    if (response?.status === 200) {
      dispatch(logout());
      navigate("/login");
    }
  } catch (err) {
    dispatch(logout());
    navigate("/login");
    toast.error(err?.response?.data?.message || "Login failed!");
  }
};
